import type { FC, SVGProps } from 'react';

export const SearchIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      fill="currentColor"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill="currentColor"
        d="M15.102 14.1189L10.4645 9.48141C11.1841 8.55106 11.5734 7.41356 11.5734 6.21713C11.5734 4.78499 11.0145 3.44213 10.0038 2.42963C8.99306 1.41713 7.64663 0.859985 6.21627 0.859985C4.78592 0.859985 3.43949 1.41891 2.42877 2.42963C1.41627 3.44034 0.859131 4.78499 0.859131 6.21713C0.859131 7.64749 1.41806 8.99391 2.42877 10.0046C3.43949 11.0171 4.78413 11.5743 6.21627 11.5743C7.4127 11.5743 8.54842 11.185 9.47877 10.4671L14.1163 15.1028C14.1299 15.1164 14.146 15.1272 14.1638 15.1346C14.1816 15.142 14.2006 15.1458 14.2198 15.1458C14.2391 15.1458 14.2581 15.142 14.2759 15.1346C14.2937 15.1272 14.3098 15.1164 14.3234 15.1028L15.102 14.3261C15.1156 14.3125 15.1264 14.2963 15.1338 14.2785C15.1411 14.2608 15.1449 14.2417 15.1449 14.2225C15.1449 14.2032 15.1411 14.1842 15.1338 14.1664C15.1264 14.1487 15.1156 14.1325 15.102 14.1189ZM9.04485 9.0457C8.2877 9.80106 7.28413 10.2171 6.21627 10.2171C5.14842 10.2171 4.14485 9.80106 3.3877 9.0457C2.63235 8.28856 2.21627 7.28499 2.21627 6.21713C2.21627 5.14927 2.63235 4.14391 3.3877 3.38856C4.14485 2.6332 5.14842 2.21713 6.21627 2.21713C7.28413 2.21713 8.28949 2.63141 9.04485 3.38856C9.8002 4.1457 10.2163 5.14927 10.2163 6.21713C10.2163 7.28499 9.8002 8.29034 9.04485 9.0457Z"
      />
    </svg>
  );
};
